module.exports = __webpack_public_path__ + "img/customer_design_4.78e6e52.webp";